import { useContext } from 'react';

import {
  RichTextEditorActionContext,
  RichTextEditorValueContext,
} from './context';

const useRichTextEditorValue = () => {
  const context = useContext(RichTextEditorValueContext);
  if (!context) {
    throw new Error(
      'useRichTextEditorValue must be used within a <RichTextEditorContext />',
    );
  }
  return context;
};

const useRichTextEditorAction = () => {
  const context = useContext(RichTextEditorActionContext);
  if (!context) {
    throw new Error(
      'useRichTextEditorAction must be used within a <RichTextEditorContext />',
    );
  }
  return context;
};

export { useRichTextEditorAction, useRichTextEditorValue };
